<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2Ji5Zb/tc-custom/9781504052733.jpg?1734274840189" alt="This image is the cover for the book Blaine McCracken Novels Volume One, The Blaine McCracken Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blaine McCracken Novels Volume One, The Blaine McCracken Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>USA Today</i>–bestselling author’s first three pulse-pounding thrillers featuring his heroic rogue agent—“Nobody writes action like Jon Land” (John Lescroart).</b><br/>  <br/> “Land is one of the best all-out action writers in the business,” and his Blaine McCracken series takes the thriller genre to a whole new level (<i>The Los Angeles Review of Books</i>). Collected in this volume are the first three adventures of the “no-holds-barred rogue agent” who nukes the rulebook to save the world (<i>Publishers Weekly</i>).<br/>  <br/><i>The Omega Command</i>: A space shuttle is destroyed in flight, and the CIA recalls disgraced agent Blaine McCracken to uncover the villains who are responsible.<br/>  <br/><i>The Alpha Deception</i>: A space-borne superweapon rains death down on a small American town, and McCracken races to learn who pulled the trigger—before the fearsome beam turns on Washington.<br/>  <br/><i>The Gamma Option</i>: When his estranged son is kidnapped, McCracken goes to work for a group of Arab militants to recover the child he never knew—and bring the Middle East back from the brink of war.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jon Land
      </h2>
      
      <p class="authorDescription body article">Jon Land is the <I>USA Today</I>&ndash;bestselling author of <I>The </I><I>Tenth Circle</I>,<I> Pandora&rsquo;s Temple</I> (winner of the 2012 International Book Award and nominated for a 2013 Thriller Award for Best E-Book Original Novel), and five other books featuring Blaine McCracken, Land&rsquo;s iconic series hero, for Open Road Integrated Media. He also pens the critically acclaimed Caitlin Strong series, which includes <I>Strong Rain Falling</I> and <I>Strong Darkness</I>, winners of the USA Best Book Award in 2013 and 2014, in the Mystery and Thriller categories, respectively. Now with thirty-seven books to his credit,&#160;Land will soon be working on a new title for Open Road, in which McCracken teams up with Land&rsquo;s other bestselling series hero, Jared Kimberlain (<I>The Eighth Trumpet </I>and<I> The Ninth Dominion</I>).&#160;Land lives in Providence, Rhode Island, and can be found at jonlandbooks.com and on Twitter with the handle @jondland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5296d8f3